import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Modal from 'Views/Page/Content/Modal';
import NavigationWithContext from 'Components/ComponentLibrary/Organisms/NavigationWithContext';
import { NavigationProvider } from 'Components/ComponentLibrary/Organisms/NavigationWithContext/NavigationContext';
import PropTypes from 'prop-types';
import usePageTemplate from './Templates';

const PageContentContent = ({ navigationHeaderLeft, navigationHeaderRight }) => {
  const {
    pageContentCollection,
    pageContentResource,
    loadPageContentLink,
    setPageContentCollection,
    refreshPageContentCollection,
    setDeprecatedDebouncePageLoads,
  } = usePageContentContext();
  const Template = usePageTemplate(pageContentCollection, pageContentResource, setDeprecatedDebouncePageLoads);

  return (
    <>
      <NavigationProvider pageResource={pageContentResource} loadPageLink={loadPageContentLink} navigationHeaderLeft={navigationHeaderLeft} navigationHeaderRight={navigationHeaderRight}>
        <NavigationWithContext />
        <Template
          key={
            // Some resource types use the same templates (e.g. GenericTableTemplate is used frequently).
            // Some of those templates do not render properly when their props are changed.
            // Take GenericTableTemplate for example. Its ItemContext.jsx file contains this code:
            //   useComponentDidMount(() => {
            //     return fetchCollectionByLink(pageContentResource.relationship(fr.relationships.items.name).link('related'));
            //   });
            // That means if you go from one page that uses GenericTableTemplate to another with the same template, it will not fetch new data.
            // There may be a lot of similar bugs like this, so we use a key to force react to dismount and remount the entire template if a different type is used.
            // Historically this was accomplished by wrapping each template in an HOC (withSiteNavigation) so that each template was a different component, but now that's been removed, requiring this key
            pageContentCollection?.meta().type()
          }
          collection={pageContentCollection}
          resource={pageContentResource}
          loadCollectionByLink={loadPageContentLink}
          setCollection={setPageContentCollection}
          refreshCollection={refreshPageContentCollection}
        />
        <Modal />
      </NavigationProvider>
    </>
  );
};
PageContentContent.propTypes = {
  navigationHeaderLeft: PropTypes.object,
  navigationHeaderRight: PropTypes.object,
};
PageContentContent.defaultProps = {
  navigationHeaderLeft: undefined,
  navigationHeaderRight: undefined,
};

export default PageContentContent;
